import styled from 'styled-components'

export const Message = styled.p`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  font: normal normal normal 16px/25px Inter;
  color: ${props => props.theme.colors.color545e6c};
`
